import { render, staticRenderFns } from "./ListaPalabras.vue?vue&type=template&id=4c6849b8&"
import script from "./ListaPalabras.vue?vue&type=script&lang=js&"
export * from "./ListaPalabras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports